mutation AttachEventYouTubeForeignSource($eventId: ID!, $videoUrl: String!, $attested: Boolean!) {
  result: StreamToolsAttachEventYouTubeForeignSource(eventId: $eventId, videoUrl: $videoUrl, attested: $attested) {
    eventId
    attached
    refusalCode
    message
    source {
      channelId
      videoId
      attestedAt
      channelTitle
      channelProfileImageUrl
    }
    session {
      sessionId
      eventId
      scope
      status
      startedAt
      stoppedAt
      stopReason
      channelId
      channelTitle
      videoId
      channelProfileImageUrl
      foreignEvent
    }
  }
}
